import { render, staticRenderFns } from "./severItem.vue?vue&type=template&id=9704767e&scoped=true"
var script = {}
import style0 from "./severItem.vue?vue&type=style&index=0&id=9704767e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9704767e",
  null
  
)

export default component.exports